import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";

export const LoginModal = ({ isLoginModal, handleCloseLogin }) => {
  const { t } = useTranslation();

  return (
    <Modal show={isLoginModal} onHide={handleCloseLogin}>
      <Modal.Body>
        <div className="promocode_content login_first">
          <Link to="" onClick={handleCloseLogin}>
            +
          </Link>
          <h2>{t("complete-profile-candidate")}</h2>
          <img src={window.location.origin + "/images/landing.png"} />
          <p>
            {t(
              "answer-question-help"
            )}
          </p>
          <button>
            <Link to={"/complete-parents-profile"}>
              {t("text-complete-profile")}
            </Link>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
